import type { Router } from "vue-router";
import { installQuizGuards } from "./guards";

export function installQuizRouterHooks(router: Router) {
    installQuizGuards(router);
}
